export default "__VITE_ASSET__meBwU$sU__"